<mat-card class="full-height-container">
  <div style="display: flex; justify-content: flex-end; padding: 8px 16px">
    <button mat-stroked-button type="button" [disabled]="isCheckingPendingReopen()" (click)="toggleShowClosedAndDeleted()">
      <mat-icon>{{ showClosedAndDeleted ? 'visibility_off' : 'visibility' }}</mat-icon>
      {{ (showClosedAndDeleted ? 'dataManagement.dataExchangeRequests.hideClosedDeleted' : 'dataManagement.dataExchangeRequests.showClosedDeleted') | transloco }}
    </button>
  </div>
  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)" class="full-height-container">
    <mat-tab label="{{ 'dataManagement.dataExchangeRequests.tabSent' | transloco }}">
      <div class="tab-container">
        <app-data-exchange-request-table
          [dataSource]="sentDataSource"
          [isReceived]="false"
          [isClosed]="false"
          [displayedColumns]="displayedColumns"
          [expandRequestId]="requestIdToExpand"
          (dataReloadRequired)="loadData()">
        </app-data-exchange-request-table>

        <ng-container *ngIf="showClosedAndDeleted">
          <div class="deleted-section-title">
            {{ 'dataManagement.dataExchangeRequests.closedDeletedSectionTitle' | transloco }}
          </div>

          <app-data-exchange-request-table
            [dataSource]="closedSentDataSource"
            [isReceived]="false"
            [isClosed]="true"
            [displayedColumns]="displayedColumns"
            [expandRequestId]="requestIdToExpand"
            (dataReloadRequired)="loadData()">
          </app-data-exchange-request-table>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'dataManagement.dataExchangeRequests.tabReceived' | transloco }}">
      <div class="tab-container">
        <app-data-exchange-request-table
          [dataSource]="receivedDataSource"
          [isReceived]="true"
          [isClosed]="false"
          [displayedColumns]="displayedColumns"
          [expandRequestId]="requestIdToExpand"
          (dataReloadRequired)="loadData()">
        </app-data-exchange-request-table>

        <ng-container *ngIf="showClosedAndDeleted">
          <div class="deleted-section-title">
            {{ 'dataManagement.dataExchangeRequests.closedDeletedSectionTitle' | transloco }}
          </div>

          <app-data-exchange-request-table
            [dataSource]="closedReceivedDataSource"
            [isReceived]="true"
            [isClosed]="true"
            [displayedColumns]="displayedColumns"
            [expandRequestId]="requestIdToExpand"
            (dataReloadRequired)="loadData()">
          </app-data-exchange-request-table>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-card>
